import { reducer as storeReducer } from 'store/common';
import ActionType from './actionType';

const initialState = {
  showWarning: false,
};

const setShowWarning = (state, payload) => ({
  ...state,
  showWarning: payload.showWarning,
});

const actionsMapping = {
  [ActionType.SET_SHOW_WARNING]: setShowWarning,
};

const reducer = (state = initialState, action) => storeReducer(actionsMapping, state, action);

export default reducer;
